export default "__VITE_ASSET__T44sBETI__"